<template>
  <div class="mt-4  px-5">
    <v-alert
        dense
        text
        shaped
        type="info">
      <b>Hinweis:</b>
      <div>
        Hier werden alle Arbeitsstunden dargestellt, die durch die schuetzenbuch.de Einträge als Standaufsicht und
        Schiessleiter entstanden sind.
      </div>
    </v-alert>
    <v-data-table
        :headers="headers"
        :items="comp_filteredWorkingHours"
        sort-by="beginn"
        :sort-desc="[true]"
        class="elevation-1"
        ref="WorkingHours"
        no-data-text="Keine Arbeitsstunden vorhanden, oder nicht geladen."
        loading-text="Daten werden geladen..."
    >
      <template v-slot:top>
        <v-toolbar
            flat
            color="blue lighten-1"
            dark
        >
          <v-toolbar-title>Arbeitsstunden</v-toolbar-title>
          <v-spacer></v-spacer>
          <working-hours-excel-export
              v-if="$store.getters['ClubAuth/clubCan'].arbeitsstunden_full"
              :excel_data="comp_filteredWorkingHours"
              :name="comp_ClubName"
          ></working-hours-excel-export>
          <v-btn icon
                 @click="getWorkingHours">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar>

        <div style="padding: 12px 16px; border-bottom: 1px solid rgba(0,0,0,.12);">
          <v-row dense align="center">
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                  v-model="search"
                  label="Suche (Name, Funktion, ...)"
                  prepend-inner-icon="mdi-magnify"
                  outlined dense clearable hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" md="2">
              <v-text-field
                  v-model="selectedYear"
                  label="Jahr"
                  type="number"
                  min="1900"
                  max="2100"
                  outlined dense hide-details
                  @change="validateAndFetchData"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" md="2">
              <v-text-field
                  v-model="date_from"
                  label="Von"
                  type="date"
                  outlined dense hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" md="2">
              <v-text-field
                  v-model="date_to"
                  label="Bis"
                  type="date"
                  outlined dense hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="auto" class="d-flex align-center">
              <v-btn text small @click="resetFilters">
                <v-icon left small>mdi-filter-off</v-icon>
                Zurücksetzen
              </v-btn>
              <span class="caption grey--text ml-2">
                {{ comp_filteredWorkingHours.length }}/{{ comp_WorkingHours.length }}
              </span>
            </v-col>
          </v-row>
        </div>
      </template>

      <template v-slot:item.Datum="{ item }">
        <span>{{
            new Date(item.Datum.replace(" ", "T")).toLocaleString([], {
              dateStyle: 'short'
            })
          }}</span>
      </template>

      <template v-slot:item.ende="{ item }">
        <span>{{
            new Date(item.ende.replace(" ", "T")).toLocaleString([], {
              dateStyle: 'short',
              timeStyle: 'short'
            })
          }}</span>
      </template>

      <template v-slot:item.beginn="{ item }">
        <span>{{
            new Date(item.beginn.replace(" ", "T")).toLocaleString([], {
              dateStyle: 'short',
              timeStyle: 'short'
            })
          }}</span>
      </template>


      <template v-slot:item.shooting_function_name="{ item }">
        <span>{{ item.shooting_function_name || item.Aufsicht || item.funktion_name || (isNaN(item.funktion) ? item.funktion : getFunctionName(item.shooting_function_id || item.funktion)) }}</span>
      </template>

    </v-data-table>


  </div>
</template>

<script>
import WorkingHoursExcelExport from "@/views/component/WorkingHoursExcelExport.vue";
import swal from "sweetalert2";

export default {
  name: 'workinghours',
  components: {WorkingHoursExcelExport},
  data: () => ({
    dialog: false,
    dialogDelete: false,
    selectedYear: new Date().getFullYear(),
    search: '',
    date_from: null,
    date_to: null,
    headers: [
      {
        align: 'Name',
        sortable: false,
      },
      {text: 'Name', value: 'user_name'},
      {text: 'Vorname', value: 'user_vorname'},
      {text: 'Mitgliedsnummer', value: 'user_mitgliednummer'},
      {text: 'Datum', value: 'Datum'},
      {text: 'Stunden', value: 'stunden'},
      {text: 'Beginn', value: 'beginn'},
      {text: 'Ende', value: 'ende'},
      {text: 'Funktion', value: 'shooting_function_name'},
      {text: 'Stand', value: 'standnamen'},
      {text: 'Beschreibung', value: 'Beschreibung'}
    ],


  }),

  computed: {
    comp_WorkingHours() {
      return this.$store.state.ClubApp.WorkingHours;
    },
    comp_filteredWorkingHours() {
      let data = this.comp_WorkingHours || [];

      if (this.search && this.search.trim()) {
        const s = this.search.toLowerCase().trim();
        data = data.filter(item =>
            (item.user_name && item.user_name.toLowerCase().includes(s)) ||
            (item.user_vorname && item.user_vorname.toLowerCase().includes(s)) ||
            (item.user_mitgliednummer && item.user_mitgliednummer.toString().toLowerCase().includes(s)) ||
            (item.shooting_function_name && item.shooting_function_name.toLowerCase().includes(s)) ||
            (item.Aufsicht && item.Aufsicht.toLowerCase().includes(s)) ||
            (item.funktion_name && item.funktion_name.toLowerCase().includes(s)) ||
            (item.standnamen && item.standnamen.toLowerCase().includes(s)) ||
            (item.Beschreibung && item.Beschreibung.toLowerCase().includes(s))
        );
      }

      if (this.date_from) {
        const from = new Date(this.date_from + 'T00:00:00');
        data = data.filter(item => new Date(item.beginn.replace(' ', 'T')) >= from);
      }

      if (this.date_to) {
        const to = new Date(this.date_to + 'T23:59:59');
        data = data.filter(item => new Date(item.beginn.replace(' ', 'T')) <= to);
      }

      return data;
    },
    comp_ClubName() {
      return this.$store.getters['ClubAuth/isClubName'];
    }
  },

  mounted() {
    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
    if (this.$route.query.year) {
      this.selectedYear = this.$route.query.year;
    }
    this.getWorkingHours();
  },

  methods: {

    getWorkingHours() {
      const Data = {
        Year: this.selectedYear
      }
      this.$store.dispatch('ClubApp/getWorkingHours', Data)
    },

    getFunctionName(id) {
      const map = { 1: "Schütze", 2: "Standaufsicht", 3: "Schießsportleiter" };
      return map[id] || "Unbekannt";
    },

    validateAndFetchData() {
      if (
          this.selectedYear >= 1900 &&
          this.selectedYear <= 2100 &&
          Number.isInteger(Number(this.selectedYear))
      ) {
        this.getWorkingHours();
      } else {
        swal.fire("Bitte gib ein gültiges Jahr ein.");
      }
    },

    resetFilters() {
      this.search = '';
      this.date_from = null;
      this.date_to = null;
      this.selectedYear = new Date().getFullYear();
      this.getWorkingHours();
    },

    initialize() {
      this.getWorkingHours();
    },

  },
}
</script>

<style scoped>
.year-picker {
  max-width: 100px;
  padding-top: 25px;
  margin-left: 10px;
  margin-right: 30px;
}

.mySubheader {
  font-weight: bold;
}

#Hinweis_span {
  font-weight: bold;
}
</style>

